import * as DEFAULTS from '../config';
import en from './en/translation.json';
import es from './es/translation.json';
import fr from './fr/translation.json';
import it from './it/translation.json';
import pt from './pt/translation.json';

const locales = {
  en,
  es,
  fr,
  it,
  pt,
};

const getProp = (obj, key) =>
  key.split('.').reduce((o, x) => (typeof o === 'undefined' || o === null ? o : o[x]), obj);

export function getLang(lang) {
  if (!lang) {
    return DEFAULTS.DEFAULT_LANGUAGE;
  }

  const parsedLanguage = lang.substring(0, 2);

  return locales[parsedLanguage] ? parsedLanguage : DEFAULTS.DEFAULT_LANGUAGE;
}

export default lang => key => getProp(locales[lang], key);
